import { Plugin, Getter } from '@devexpress/dx-react-core';

export const IntegratedFilteringState = () => (
  <Plugin name="IntegratedFilteringState" dependencies={[{ name: 'IntegratedFiltering' }]}>
    <Getter name="filteredRows" computed={({ rows }) => rows} />
  </Plugin>
);

export const GridState = () => (
  <Plugin name="GridState">
    <Getter name="allRows" computed={({ rows }) => rows} />
  </Plugin>
);
